<template>
    <div class="">

        <!-- AbdullahFixed commented this  -->
        <!-- <div class="col-md-10 col-sm-12 pl-0" >
            <h4 class="atlhr-dashboard-title mt-10">Employee Leave &amp; Attendance Management<span><a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Employee Leave &amp; Attendance Management</span></h4>

        </div> -->

        <!-- AbdullahFixed commented this  -->
        <div class="row no-gutters py-2 mb-3">
          <div class="col-md-10 col-sm-12" >
            <h4 class="atlhr-dashboard-title mt-10">
                Leave & Attendance <span class="black-title"></span>
                <span>
                    <a v-bind:href="$api_url">Dashboard</a>
                    / Leave and Attendance
                </span>
            </h4>
          </div>
        </div>
        <!-- AbdullahFixed commented this  upto this -->

          <!-- AbdullahFixed added leave-attendance-dashboard -->
        <div class="mt-4 employee-tab leave-attendance-dashboard">
            <!-- AbdullahFixed added classes was b-tabs pills content-class="" nav-class=" pr-2 m-2" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">-->
            <b-tabs pills content-class="" nav-class=" pr-2 m-2 leave-attendance-dashboard-tab" nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">
                <template >
                    <b-tab lazy>
                        <template active v-slot:title>Leave</template>
                        <!-- <div class="">
                            <leaves  :flg="0"></leaves>
                        </div> -->
                        <!-- AbdullahFixed added this div -->
                        <div class="tab-item-wrapper">
                            <leaves :pageurl="this.$api_url" :flg="0"></leaves>
                        </div>
                    </b-tab>

                    <b-tab lazy>
                        <template active v-slot:title>Attendance</template>
                        <!-- AbdullahFixed added class and pageurl -->
                        <div class="tab-item-wrapper">
                            <!--<div class="mb-1 mt-5"><employees-attendance-import ></employees-attendance-import></div>-->

                            <employees-attendance :pageurl="this.$api_url" ></employees-attendance>
                        </div>
                    </b-tab>

                    <b-tab lazy>
                        <template active v-slot:title>Employee Profile</template>
                         <!-- AbdullahFixed added class and pageurl -->
                        <div class="tab-item-wrapper">
                            <employee-leave-attendance-wrapper :pageurl="this.$api_url"></employee-leave-attendance-wrapper>
                        </div>
                    </b-tab>
                    <!-- <b-tab lazy>
                        <template active v-slot:title>Reports</template>

                        <leave-attendence-report ></leave-attendence-report>


                    </b-tab> -->
                    <b-tab lazy v-if="$acl['leave-attendance/migrated-data'] > 1">
                        <template active v-slot:title>Migrated Data</template>
                        <!-- AbdullahFixed added class and pageurl -->
                        <div class="past-data">

                            <leaves-past-data :pageurl="this.$api_url"></leaves-past-data>
                        </div>


                        <!-- start of on click report  -->
                    </b-tab>

                    <b-tab lazy v-if="$acl['leave-attendance/device-data'] > 1">
                        <template active v-slot:title>Employee Device Data</template>
                        <div class="device-signup">

                            <device-signup :pageurl="this.$api_url"></device-signup>
                        </div>


                        <!-- start of on click report  -->
                    </b-tab>

                    <b-tab lazy>
                        <template active v-slot:title>Employee Geo Locations</template>
                        <div class="p-3">
                            <employee-geo-ocations :pageurl="this.$api_url"></employee-geo-ocations>
                        </div>
                    </b-tab>




                    <!-- Ifti - 15-07-2025 - Start -->
                    <b-tab lazy>
                        <template active v-slot:title>Compensatory Leaves</template>
                        <div class="">
                            <l-a-compensatory-leaves-dashboard></l-a-compensatory-leaves-dashboard>
                        </div>
                    </b-tab>
                    <!-- Ifti - 15-07-2025 - End -->

                </template>

            </b-tabs>

        </div>





    </div>
</template>
<script>

    import moment from 'moment'


    export default{

        mounted() {
            // this.$refs.trzcalendar;
        },
       props: [],
        components: {

        },
        data(){

            return {

                // cu:window.location.href,
                // ce:false,



            }
        },
        methods:{

        },
        created: function(){


        },
        computed:
        {

        }
    }
</script>
<style scoped>
.modal-lg, .modal-xl {
    max-width: 2000px !important;
}
</style>
